import React, { useState, createContext } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { HelmetProvider, Helmet } from 'react-helmet-async'
import { injectIntl } from 'gatsby-plugin-react-intl'
import Seo from '../../seo/SEO'
import { ContentWrapper } from '@components/ui/wrappers/Wrappers'
import Navbar from './navbar/Navbar'
import Footer from './Footer'
import _find from 'lodash/find'
import { ThemeProvider } from '@mui/material/styles'
import muiTheme from '@configs/muiTheme'
import ModalContact from '@components/common/ModalContact'
import getGlobalDocument from '@configs/getGlobalDocument'
// import styled from 'styled-components'
// import { CookiesConsent } from '@components/common/CookiesConsent'
export const OpenModalContext = createContext()

const Layout = ({ children, pageName, intl }) => {
  const data = useStaticQuery(graphql`
    query {
      allSeoJson {
        edges {
          node {
            slug
            title
            description
            url
            noindex
          }
        }
      }
    }
  `)

  const seoData = data.allSeoJson.edges.map((item) => {
    return item.node
  })

  const seoMeta = _find(seoData, ['slug', pageName])
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('')

  const openContact = (type) => {
    setOpen(true)
    setType(type)
    let documentStyle = getGlobalDocument().getElementsByTagName('html')[0]
    documentStyle.style.overflow = 'hidden'
  }

  const handleClose = () => {
    setOpen(false)
    setType('')
    let documentStyle = getGlobalDocument().getElementsByTagName('html')[0]
    documentStyle.style.overflow = 'auto'
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <script
            id="Cookiebot"
            src="https://consent.cookiebot.com/uc.js"
            data-cbid="4cdb85f8-b43f-4822-8645-c9bf88b0b450"
            type="text/javascript"
          />
          <script
            id="CookieDeclaration"
            src="https://consent.cookiebot.com/4cdb85f8-b43f-4822-8645-c9bf88b0b450/cd.js"
            type="text/javascript"
            async
          />
          <script id="paddlejs" async src="https://cdn.paddle.com/paddle/paddle.js" />
          <script>
            {`(function(p,t,n,e,r,o){ p['__partnerObject']=r;function f(){
            var c={ a:arguments,q:[]};var r=this.push(c);return "number"!=typeof r?r:f.bind(c.q);}
            f.q=f.q||[];p[r]=p[r]||f.bind(f.q);p[r].q=p[r].q||f.q;o=t.createElement(n);
            var _=t.getElementsByTagName(n)[0];o.async=1;o.src=e+'?v'+(~~(new Date().getTime()/1e6));
            _.parentNode.insertBefore(o,_);})(window, document, 'script', 'https://app.partnero.com/js/universal.js', 'po');
            window.po('settings', 'assets_host', 'https://assets.partnero.com');
            window.po('program', '${process.env.PARTNERO_PROGRAM_ID}', 'load');`}
          </script>

          <script>{`(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`}</script>
          <script async src="https://r.wdfl.co/rw.js" data-rewardful={process.env.REWARDFUL_ID}></script>
          <script>{`(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,${process.env.OPTIN_MONSTER_USER_ID},${process.env.OPTIN_MONSTER_ACCOUNT_ID});`}</script>
          <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        </Helmet>
      </HelmetProvider>
      <ThemeProvider theme={muiTheme}>
        {seoMeta && (
          <Seo
            title={intl.formatMessage({ id: seoMeta.title })}
            description={intl.formatMessage({ id: seoMeta.description })}
            pathname={seoMeta.url}
            noindex={seoMeta.noindex}
          />
        )}
        <Navbar />
        <div className="overlay"></div>

        <OpenModalContext.Provider value={{ openContact }}>
          <ContentWrapper>
            <ModalContact open={open} type={type} handleClose={handleClose} intl={intl} />
            {children}
            {/*<ProductHuntWrapper>*/}
            {/*  <a href="https://www.producthunt.com/products/ideabuddy" target="_blank" rel="noreferrer">*/}
            {/*    <img*/}
            {/*      src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=461174&theme=light"*/}
            {/*      alt="IdeaBuddy - Bring&#0032;your&#0032;business&#0032;idea&#0032;to&#0032;life | Product Hunt"*/}
            {/*      width="100%"*/}
            {/*      height="48"*/}
            {/*    />*/}
            {/*  </a>*/}
            {/*</ProductHuntWrapper>*/}
          </ContentWrapper>

          <Footer />
          {/*<CookiesConsent />*/}
        </OpenModalContext.Provider>
      </ThemeProvider>
    </>
  )
}

export default injectIntl(Layout)

// const ProductHuntWrapper = styled.div`
//   position: fixed;
//   bottom: 16px;
//   left: 20px;
//   z-index: 1;
// `
